/**
 *    Map style
 */

(function ($) {
  Drupal.behaviors.mapStyle = {
    /**
     * return map styles
     * @return style
     */
    mapStyle() {
      const style = {
        default: [
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'transit',
            stylers: [
              {
                saturation: -50,
              },
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'on',
              },
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                saturation: -50,
              },
              {
                weight: 1.8,
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {},
          {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
        ],
      };

      return style;
    },
  };
}(jQuery));

// end of map-style.js
